import { storage } from '../../lib/storage'

const TTL_MS = 5 * 60 * 1000

export async function cacheGet(key) {
  try {
    const raw = await storage.get(key)
    if (!raw) return null
    const { ts, data } = JSON.parse(raw)
    if (Date.now() - ts > TTL_MS) { await storage.remove(key); return null }
    return data
  } catch { return null }
}

export async function cacheSet(key, data) {
  try { await storage.set(key, JSON.stringify({ ts: Date.now(), data })) } catch {/* ignore */}
}

export const CACHE_KEY = (leagueId, idStage, type) => `lb_${leagueId}_${idStage}_${type}`
